import Fuse from 'fuse.js';
import { AccessibleTeacherItem, ManagedClassroomSearchItem } from './types';

const classroomFuseOptions: Fuse.IFuseOptions<ManagedClassroomSearchItem> = {
  includeScore: true,
  threshold: 0.35,
  keys: [
    { name: 'teacherName', weight: 0.5 },
    { name: 'classroomName', weight: 0.25 },
    { name: 'schoolName', weight: 0.15 },
    { name: 'districtName', weight: 0.1 },
  ],
};

const teacherFuseOptions: Fuse.IFuseOptions<AccessibleTeacherItem> = {
  includeScore: true,
  threshold: 0.35,
  keys: [
    { name: 'teacherName', weight: 0.55 },
    { name: 'email', weight: 0.3 },
    { name: 'schoolName', weight: 0.15 },
  ],
};

const districtFuseOptions: Fuse.IFuseOptions<string> = {
  includeScore: true,
  threshold: 0.35,
};

export function filterManagedClassrooms(query: string, items: ManagedClassroomSearchItem[]) {
  const normalized = query.trim();
  if (!normalized) {
    return items;
  }

  const fuse = new Fuse(items, classroomFuseOptions);
  return fuse.search(normalized).map((result) => result.item);
}

export function filterTeachers(query: string, items: AccessibleTeacherItem[]) {
  const normalized = query.trim();
  if (!normalized) {
    return items;
  }

  const fuse = new Fuse(items, teacherFuseOptions);
  return fuse.search(normalized).map((result) => result.item);
}

export function filterDistricts(query: string, items: string[]) {
  const normalized = query.trim();
  if (!normalized) {
    return items;
  }

  const fuse = new Fuse(items, districtFuseOptions);
  return fuse.search(normalized).map((result) => result.item);
}
